import { render, staticRenderFns } from "./OlympicsRound.vue?vue&type=template&id=15f38536&scoped=true&"
import script from "./OlympicsRound.vue?vue&type=script&lang=js&"
export * from "./OlympicsRound.vue?vue&type=script&lang=js&"
import style0 from "./OlympicsRound.vue?vue&type=style&index=0&id=15f38536&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f38536",
  null
  
)

export default component.exports